module.exports = __webpack_public_path__ + "img/ai.29595621.svg";